import { CPopover } from "@coreui/react";
import {
  ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_ERROR,
  ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_CHOICES,
  ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_UPLOADED_TO_SET,
  ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_APPROVED_BY_SET,
  ElectronicDocumentDisablement,
  ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_SET_UNKNOWN_ERROR,
} from "../../models/electronic-document-disablement";

interface DisablementCrudStatusProps {
  disbablement: ElectronicDocumentDisablement;
}

const DisablementCrudStatus: React.FC<DisablementCrudStatusProps> = ({
  disbablement,
}) => {
  let badgeClassName = "badge-info";

  if (
    disbablement.status ===
    ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_UPLOADED_TO_SET
  ) {
    badgeClassName = "badge-warning";
  }

  if (disbablement.status === ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_ERROR) {
    badgeClassName = "badge-danger";
  }

  if (
    disbablement.status ===
    ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_APPROVED_BY_SET
  ) {
    badgeClassName = "badge-success";
  }

  return (
    <td className="text-center">
      <span
        className={`badge badge-pill ${badgeClassName}`}
        style={{ fontSize: "14px" }}
      >
        {ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_CHOICES.get(
          disbablement.status!
        )}{" "}
        {disbablement.status ===
        ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_ERROR ? (
          <CPopover
            content={
              <ul
                style={{
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  paddingBottom: "0px",
                  marginBottom: "0px",
                }}
              >
                <li>Código: {disbablement.setResponseCode}</li>
                <li>Descripción: {disbablement.setResponseDescription}</li>
              </ul>
            }
            placement="top"
            trigger="click"
          >
            <span
              className="fa fa-info-circle"
              style={{ cursor: "pointer" }}
            ></span>
          </CPopover>
        ) : (
          <></>
        )}
        {disbablement.status ===
        ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_SET_UNKNOWN_ERROR ? (
          <CPopover
            content={
              <ul
                style={{
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  paddingBottom: "0px",
                  marginBottom: "0px",
                }}
              >
                <li>Error: {disbablement.setError}</li>
              </ul>
            }
            placement="top"
            trigger="click"
          >
            <span
              className="fa fa-info-circle"
              style={{ cursor: "pointer" }}
            ></span>
          </CPopover>
        ) : (
          <></>
        )}
      </span>
    </td>
  );
};

export default DisablementCrudStatus;
